/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pool_GlobalInputs */

const bn_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`গ্লোবাল`)
};

const de_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global`)
};

const el_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Καθολικός`)
};

const en_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global`)
};

const es_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global`)
};

const fr_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mondial`)
};

const hi_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वैश्विक`)
};

const hu_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Globális`)
};

const id_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global`)
};

const it_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Globale`)
};

const ja_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グローバル`)
};

const ko_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`글로벌`)
};

const nl_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Globaal`)
};

const pl_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Światowy`)
};

const pt_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global`)
};

const ru_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Глобальный`)
};

const sv_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global`)
};

const tr_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Küresel`)
};

const uk_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Глобальний`)
};

const vi_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toàn cầu`)
};

const zh_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全球的`)
};

const zh_hant_pool_global = /** @type {(inputs: Pool_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全球的`)
};

/**
* | output |
* | --- |
* | "Global" |
*
* @param {Pool_GlobalInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const pool_global = /** @type {((inputs?: Pool_GlobalInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pool_GlobalInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_pool_global(inputs)
	if (locale === "de") return de_pool_global(inputs)
	if (locale === "el") return el_pool_global(inputs)
	if (locale === "en") return en_pool_global(inputs)
	if (locale === "es") return es_pool_global(inputs)
	if (locale === "fr") return fr_pool_global(inputs)
	if (locale === "hi") return hi_pool_global(inputs)
	if (locale === "hu") return hu_pool_global(inputs)
	if (locale === "id") return id_pool_global(inputs)
	if (locale === "it") return it_pool_global(inputs)
	if (locale === "ja") return ja_pool_global(inputs)
	if (locale === "ko") return ko_pool_global(inputs)
	if (locale === "nl") return nl_pool_global(inputs)
	if (locale === "pl") return pl_pool_global(inputs)
	if (locale === "pt") return pt_pool_global(inputs)
	if (locale === "ru") return ru_pool_global(inputs)
	if (locale === "sv") return sv_pool_global(inputs)
	if (locale === "tr") return tr_pool_global(inputs)
	if (locale === "uk") return uk_pool_global(inputs)
	if (locale === "vi") return vi_pool_global(inputs)
	if (locale === "zh") return zh_pool_global(inputs)
	return zh_hant_pool_global(inputs)
});